import React from 'react'

import './glyphter-font/css/Glyphter.css'

function HederaIcon({ fontSize = '0.9em' }) {
    return <i className='icon-hedera-hbar-logo' style={{ fontSize: fontSize, verticalAlign: '-.0667em' }}></i>
}

export { HederaIcon }
